import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ProgressSpinner
  from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import axios from 'axios';
import AxiosDataWrapper
  from '@avtechsoftware/react-component-library/src/components/common/AxiosDataWrapper/AxiosDataWrapper';
import AxiosDataIsLoaded
  from '@avtechsoftware/react-component-library/src/components/common/AxiosDataWrapper/AxiosDataIsLoaded/AxiosDataIsLoaded';
import envConfig from '../../../envConfig';
import {
  generateResourceURLFromParam,
  getResourceIdFromURLParam,
} from '../../../utility/orderAndQuoteUtil';
import {
  withPublicContext,
} from '../../../contexts/PublicContext/PublicContext';
import RaApiQuoteMapperV1 from '../../../classes/mappers/quotes/RaApiQuoteMapperV1';
import { QuoteDetails } from '../../quotes/QuoteDetails/QuoteDetails';

class PublicQuotePaymentPage extends React.Component {
  constructor(props) {
    super(props);
    const { id } = props.match.params;
    const parsedId = getResourceIdFromURLParam(id);
    this.state = {
      quote: { quoteNumber: `QUO-${parsedId}` },
      loading: true,
      loadError: false,
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    const { match } = this.props;
    const { id } = match.params;

    this.setState({ loading: true });
    return axios.get(
      `${envConfig.apiUrl}/api/v1/quotes/public/${generateResourceURLFromParam(id)}`,
    ).then((quoteResponse) => {
      if (quoteResponse.data.success === false) {
        this.setState({
          loadError: true,
        });
      }
      const mappedQuote = RaApiQuoteMapperV1
        .mapJsonToQuote(quoteResponse.data.data.quoteDetails);
      this.setState({
        quote: mappedQuote,
        loading: false,
      });
    }).catch(() => {
      this.setState({
        loadError: true,
      });
    });
  }

  onCloseError() {
    this.setState({ loadError: false });
  }

  render() {
    const {
      loading, loadError, quote,
    } = this.state;
    return (
      <div className="container-fluid mt-3 overflow-hidden">
        <div className="col-12">
          {loadError && (
          <div className="row">
            <div className="col">
              <ErrorBanner onCloseError={this.onCloseError}>
                Unexpected Error retrieving quote.
              </ErrorBanner>
            </div>
          </div>
          )}
          {loading ? ((
            <div className="row d-flex justify-content-center mt-5">
              <div>
                <ProgressSpinner />
              </div>
            </div>
          ))
            : (
              <AxiosDataWrapper url="/order/country-list" config={{ dataTitle: 'countryList' }}>
                <AxiosDataIsLoaded>
                  <QuoteDetails
                    quoteDetails={quote}
                    isPublicView
                    supportsRoles={false}
                    samlEnabled={false}
                    userHasGrantAccessPrivileges={false}
                    email=""
                  />
                </AxiosDataIsLoaded>
              </AxiosDataWrapper>
            )}
        </div>
      </div>
    );
  }
}

PublicQuotePaymentPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.string }) })
    .isRequired,
};

export { PublicQuotePaymentPage };
export default withRouter(withPublicContext(PublicQuotePaymentPage));
